/** @jsxRuntime classic */
/** @jsx jsx */
import React, { useMemo } from 'react';
import { css, jsx } from '@emotion/react';
import { useTranslation } from 'react-i18next';
import Typography from '@mui/material/Typography';
import SlackDestinationPicker from '../../integrations/settings/SlackDestinationPicker';
import GoogleDrivePickerButton from '../../integrations/settings/GoogleDrivePickerButton';

export default function TemplateSettings({ template, settings, onChange }) {
  const { t } = useTranslation();

  // Check if any nodes in the template require settings
  const nodesRequiringSettings = useMemo(() => {
    return template.data.nodes.filter((node) => {
      // Handle both Slack and Google Drive nodes
      return node.type === 'slack' || node.type === 'googleDrive';
    });
  }, [template]);

  if (nodesRequiringSettings.length === 0) {
    return null;
  }

  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
        gap: 16px;
        padding: 16px;
      `}
    >
      <Typography variant="subtitle1" fontWeight="600">
        {t('Inställningar')}
      </Typography>
      {nodesRequiringSettings.map((node) => {
        if (node.type === 'slack') {
          return (
            <div
              key={node.id}
              css={css`
                display: flex;
                flex-direction: column;
                gap: 8px;
              `}
            >
              <Typography 
                variant="body2" 
                color="text.secondary"
                css={css`
                  margin-bottom: 8px;
                `}
              >
                {t('Välj användare eller kanal för Slack-meddelanden')}
              </Typography>
              <SlackDestinationPicker
                value={settings[node.id]?.destination}
                onChange={(newValue) => {
                  onChange({
                    ...settings,
                    [node.id]: {
                      ...settings[node.id],
                      destination: newValue,
                    },
                  });
                }}
              />
            </div>
          );
        }
        if (node.type === 'googleDrive') {
          return (
            <div
              key={node.id}
              css={css`
                display: flex;
                flex-direction: column;
                gap: 8px;
              `}
            >
              <Typography 
                variant="body2" 
                color="text.secondary"
                css={css`
                  margin-bottom: 8px;
                `}
              >
                {t('Välj mapp för att spara sammanfattningen')}
              </Typography>
              <GoogleDrivePickerButton
                folder={{
                  id: settings[node.id]?.folder,
                  name: settings[node.id]?.folderName
                }}
                onClick={(folder) => {
                  onChange({
                    ...settings,
                    [node.id]: {
                      ...settings[node.id],
                      folder: folder.id,
                      folderName: folder.name,
                    },
                  });
                }}
              />
            </div>
          );
        }
        return null;
      })}
    </div>
  );
} 
